import { BackButton as LegacyBackButton } from "@/components/Funnel/BackButton";

import { useFunnelExperimentContext } from "../funnel-experiment-context";

export function BackButton({ className }: { className?: string }) {
  const funnelExperimentContext = useFunnelExperimentContext();

  if (funnelExperimentContext.showNewQuestionsAndButtons()) {
    return null;
  }

  return (
    <div className={className}>
      <LegacyBackButton />
    </div>
  );
}
